import React from 'react';

import type { NodeViewRenderer, NodeViewRenderers } from './../../ricos-types';
import { Node_Type } from './../../ricos-types';

import File from './file';

const FileRenderer: NodeViewRenderer = ({ node, ...props }) => {
  return <File key={node.id} node={node} {...props} />;
};

export const nodeViewRenderers: NodeViewRenderers = {
  [Node_Type.FILE]: FileRenderer,
};
